<template>
  <div class="min-h-screen bg-gray-50">
    <Header />
    <main class="p-6">
      <div class="max-w-7xl mx-auto">
        <h1 class="text-3xl font-bold text-gray-900 mb-8">API Key Management</h1>
        <div class="card mb-8">
          <div class="card-body">
            <p class="text-gray-600">API key management coming soon...</p>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import Header from '@/components/common/Header.vue'
</script>
